var _g, _circle, _path, _circle2, _path2, _circle3, _path3, _circle4, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBiologyicon = function SvgBiologyicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "props.stroke",
    strokeWidth: 1.248,
    d: "M139.2 18.6c-1-1.7-2.3-2.9-4.2-3.2-2.3-.1-3.9.7-4.7 2.3-.7 1.8-.4 3.5-.7 5.5-1.6 7.4-8.7 20.2-17.3 24.6-2.1 1.2-7.2 3-7.2 3s-7.9 3-13.2-.7c-3.2-2.2-3.8-5.8-5.2-12.9-.4-2.3-.6-4.8.4-7.4.3-.8.8-1.7 1.4-2.5 3.9-5 9.9-11.1 16.6-17.8 1.9-1.9 1.2-4.2-1-6-2.5-1.7-4.8-2.1-7 0l-12.4 13c-4 4.1-6.5 8.6-7.5 13.4-.3 1.3-.8 4.2-.3 7.8 1 7.6 5.5 10.1 4.3 12.5-1.5 3.2-8.9-.6-16.7 2.9-7.1 3.2-12.1 11.2-13.1 18.6-1.3 9.7 4.8 15.6 1.7 19-2.7 2.9-7.1-1.5-15.5 1.1-6.9 2.1-12 7.5-14.9 10.6-1.6 1.7-3.1 3.6-4.5 5.6-4.2 5.4-7 10.8-8 16.3-.4 3.6.7 5.8 3.8 6.3 2.8.2 4.1-.5 5.2-3.2 1.3-4.2 2.1-5.7 3.5-8.6 4.1-7.8 13.7-16.2 18.4-17.6 1.3-.4 2.6-.6 3.4-.7 5.6-.9 8.6-1.4 10.8-.1 3.4 2 3.6 7.5 3.9 16.6 0 1 0 2.2-.3 3.7-.6 2.8-2 5.4-4.2 7.7l-11.6 12c-1.8 2.6-.7 4.2.8 5.8 2.5 2.1 4.8 2 6.5.7q7.2-6.9 13.2-13.8c3.9-4.5 5.3-9.1 5.5-14.7.4-9.6-5.7-14.8-3.2-17.7 1.9-2.3 5.9.6 13.8-.6 2.5-.4 8.9-1.6 13.8-6.1 5.9-5.3 8.7-12 8.1-20.3-.3-1.7-.8-4.3-2-7.2-1.9-4.4-3.6-5.2-3.4-6.6.8-3.9 14.7.7 26.1-6.2 0 0 9-4.2 17-28.4.6-2.1 1.1-4.1-.1-6.7zM83 89c-.7.3-2.4 1.1-6.6 1.8-7.4 1.2-11.1 1.8-13.2 0-2.6-2.2-2.4-6.4-2.1-14.5q0-1.65.6-4.5c.4-1.5.9-3 1.7-4.4 1.2-1.9 2.8-3.5 4.7-4.8 2.6-1.7 4.8-2.3 7-2.8 4.3-1 7.7-1.8 10.2 0 .9.6 3.1 2.4 4.7 5.8 1.1 2.2 1.5 5.2 1.7 11 .1 6.6-3.7 9.3-8.7 12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "props.stroke",
    stroke: "#fff",
    strokeWidth: 0.749,
    d: "m120.3 29.6-15.6-10.5c-.9-.6-1.1-1.7-.5-2.6l.8-1.2c.5-.8 1.6-1 2.4-.5l15.7 10.6c.9.6 1.1 1.7.5 2.6l-.7 1.1c-.6.9-1.8 1.1-2.6.5zm-9.5 14.5L92.5 30.5c-.8-.6-1-1.8-.4-2.6l.9-1.2c.6-.8 1.7-.9 2.4-.4L113.8 40c.8.6 1 1.8.4 2.6l-.8 1.1c-.6.8-1.8 1-2.6.4zm-84.3 80 14.6 8.4c.9.5 1.2 1.7.7 2.5l-.7 1.3c-.5.8-1.6 1.1-2.4.6L24 128.5c-.9-.5-1.2-1.7-.7-2.5l.7-1.2c.5-.9 1.7-1.2 2.5-.7zM37 108.4l16 12.5c.8.6 1 1.8.3 2.6l-.9 1.1c-.6.8-1.7.9-2.5.3l-16.1-12.6c-.8-.6-1-1.8-.3-2.6l.8-1c.7-.8 1.9-1 2.7-.3zm46.8-31.6-9.7-9.7c-.7-.7-.7-1.9 0-2.6l1-1a1.75 1.75 0 0 1 2.5 0l9.7 9.7c.7.7.7 1.9 0 2.6l-.9.9c-.7.8-1.8.8-2.6.1zm-9 9.5-9.5-10.8c-.7-.8-.6-1.9.2-2.6l1.1-1a1.76 1.76 0 0 1 2.5.2L78.6 83c.7.8.6 1.9-.2 2.6l-1 .9c-.7.7-1.9.6-2.6-.2z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.9,
    cy: 14.3,
    r: 12.7,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "props.stroke",
    d: "M43.1 7.1c2.2-2.5 5.6-2.9 6.1-2.9 2.8-.3 7 .5 7.7 2.9.4 1.3-.3 3.1-1.6 3.6-2 .8-4.1-2.4-6.2-1.6-1.5.5-2.4 2.7-1.9 4.3.6 1.8 2.9 1.6 3.7 3.3 1.4 2.6-1.8 8-4.3 7.9-3.5-.3-8.3-12-3.5-17.5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.2,
    cy: 132.6,
    r: 15.9,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "props.stroke",
    d: "M99.2 142.3c-3.1-2.7-3.6-7-3.7-7.6-.4-3.5.6-8.8 3.6-9.6 1.6-.5 3.8.4 4.5 2 1 2.5-2.9 5.1-2 7.7.7 1.9 3.4 3 5.3 2.4 2.3-.8 2-3.6 4.1-4.7 3.3-1.7 10 2.3 9.8 5.4-.2 4.4-14.7 10.5-21.6 4.4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4,
    cy: 37.9,
    r: 10.3,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "props.stroke",
    d: "M20.1 41.7c-1.1 2.4-3.7 3.5-4.1 3.7-2.1.9-5.6 1.2-6.7-.5-.5-.9-.3-2.5.5-3.2 1.4-1.1 3.7.9 5.2-.1 1-.7 1.3-2.7.5-3.8-.9-1.3-2.6-.6-3.7-1.7-1.7-1.7-.4-6.6 1.6-7.1 2.9-.6 9.3 7.4 6.7 12.7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.3,
    cy: 54.4,
    r: 9.6,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "props.stroke",
    d: "M138.4 46.4c2.5 0 4.4 1.7 4.7 2 1.6 1.4 3.2 4.2 2.2 5.8-.5.8-1.9 1.4-2.8.9-1.5-.7-.7-3.5-2.2-4.3-1-.6-2.8 0-3.4 1.1-.7 1.3.5 2.5 0 3.8-.8 2.1-5.5 3-6.6 1.5-1.6-2.2 2.6-10.8 8.1-10.8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "props.color",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 109.4,
    cy: 86.1,
    r: 5.3,
    strokeWidth: 2.172
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.4,
    cy: 73,
    r: 7.8,
    strokeWidth: 2.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.1,
    cy: 143.6,
    r: 4.3,
    strokeWidth: 1.133
  }))));
};
export default SvgBiologyicon;